import { useState, useEffect } from "react"
import { getOrFetchProfilePic } from "@/lib/n8n-api"

/**
 * Hook to get WhatsApp profile picture for a lead.
 * - If lead.foto_perfil exists in DB, uses it instantly (no API call).
 * - If not, fetches from Evolution API once and saves to DB permanently.
 *
 * @param {object} lead - Lead object with id, wa_jid, foto_perfil
 * @returns {{ picUrl: string|null, loading: boolean }}
 */
export function useWhatsAppProfilePic(lead) {
  const [picUrl, setPicUrl] = useState(lead?.foto_perfil || null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // If already have a pic from DB, use it directly
    if (lead?.foto_perfil) {
      setPicUrl(lead.foto_perfil)
      return
    }

    if (!lead?.wa_jid || !lead?.id) {
      setPicUrl(null)
      return
    }

    let cancelled = false
    setLoading(true)

    getOrFetchProfilePic(lead).then((url) => {
      if (!cancelled) {
        setPicUrl(url)
        setLoading(false)
      }
    })

    return () => { cancelled = true }
  }, [lead?.id, lead?.wa_jid, lead?.foto_perfil])

  return { picUrl, loading }
}
